import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useCalendarCategories from '../useCalendarCategories';
import FormHelper from '../../../../../helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { form, handleCreateOrUpdate, loading } = useCalendarCategories(false);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('NEW ANALYTICS CALENDAR CATEGORY')
    : t('MODIFICA TRADING CALENDAR');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              loading={loading}
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
